'use client';

import React from 'react';
import { Box, BoxProps } from '@mui/material';

type HospitalLogoProps = BoxProps & {
  logoSrc: string;
};

export const HospitalLogo = ({ logoSrc, ...props }: HospitalLogoProps) => (
  <Box
    sx={{
      position: 'relative',
      width: 140,
      height: 'auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 2,
      '& img': {
        position: 'inline-block',
        objectFit: 'contain',
        maxHeight: 100
      }
    }}
    {...props}
  >
    <img src={logoSrc} />
  </Box>
);
